import styled from '@emotion/styled';

export default styled.div`
    position: relative;
    width: 100%;

    .bg-mask {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: rgba(0,0,0,.2);
        z-index: 1;
    }

`;
